module.exports = __webpack_public_path__ + "static/4-b20aefbb87a1cdfd7b31280d421dcf68.jpg";